import { Collection } from '@nozbe/watermelondb';

import { ProcedureModel, ProcedurePayload } from '../../../../types/Procedures';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { UserModel } from '../../../../types/User';

export const getNormalizedProcedurePrice = (price?: string) => {
    const payloadPrice = (price || '').replace(',', '.');
    const isPriceNumber = !isNaN(Number(payloadPrice));

    return ((isPriceNumber && payloadPrice) || '0').replace(',', '.');
};

export const prepareCreateProcedure = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: ProcedurePayload;
    userId: string;
    organisationID: string;
    collection: Collection<ProcedureModel>;
}) =>
    collection.prepareCreate((procedure) => {
        procedure.category = payload.category;
        procedure.name = payload.name;
        procedure.description = payload.description;
        procedure.price = getNormalizedProcedurePrice(payload.price);
        procedure.available = payload.available;
        procedure.userId = userId;
        procedure.organisationId = organisationID;
    });

export const prepareProcedureUserUpdate = (
    user: UserModel,
): UserModel | undefined => {
    if (user.isProceduresAccountSetupSet) return undefined;

    return user.prepareUpdate((userElement) => {
        userElement.isProceduresAccountSetupSet = true;
    });
};

export const logAddProcedureActions = ({
    procedure,
    user,
    logDBAction,
    tableName,
}: {
    procedure: ProcedureModel;
    user?: UserModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create procedure',
        modelName: tableName,
        payload: procedure,
    });

    if (user) {
        logDBAction({
            message: 'Update user',
            modelName: 'users',
            payload: user,
        });
    }
};
